<div  class="m-0 text-lg text-[#53565b] flex items-start flex-col">

  <p  [class]=" 'sm:mb-[8px] mt-[8px] text-sm leading-5'">
    <span class="font-weight-bold-blue" > Recent uploads </span>from your <span class="font-weight-bold-blue" >{{origin}} device </span>
  </p>
</div>
@if (!fileList?.length && !isLoading) {
  <div class="flex flex-col w-full sm:h-[100%] h-[65vh]">
    <div class="flex justify-end">
      <p  style="line-height: 32px !important;margin-right: 24px;height: 32px;" class="mb-0 rounded text-[#25508E] text-xs font-bold w-32 border-solid border text-center border-[#25508E]"
        [matMenuTriggerFor]="addMenu"
        #menuAdd="matMenuTrigger"
        (menuOpened)="(menuAdd.menuOpen)"
        (menuClosed)="(menuAdd.menuOpen)"
        >
        <img src="assets/images/upload-cloud.svg" /> New Upload
      </p>
      <mat-menu #addMenu="matMenu" yPosition="below" xPosition="before" class="dropdown-menu-panel">
        <div class="upload-file">
          <input type="file" (change)="onFileChanged($event, true)" multiple #fileInput style="display: none" />
          <button mat-menu-item (click)="fileInput.click()" class="h-8 font-semibold text-sm">
            <img  src="assets/images/upload-file.svg" />
            Upload File
          </button>
        </div>
        <div class="upload-folder">
          <input
            type="file"
            name="files"
            accept=".iso"
            webkitdirectory
            mozdirectory
            directory
            multiple
            id="files"
            (change)="onFileChanged($event, false)"
            #folderInput
            style="display: none"
            />
            <button mat-menu-item (click)="folderInput.click()" class="h-8 font-semibold text-sm">
              <span style="position: relative;top: 4px;left: -4px;color: #25508E;font-size: 20px;" class="material-icons material-icons-round common-menuitem-icon">folder_open</span>Upload Folder
            </button>
          </div>
        </mat-menu>
      </div>
      <div  class=" bg-[#FFFFFF] border-solid rounded-sm mt-[24px] border-2 text-center ">
        <p  style="color: #515765;" class=" text-xl	 mt-[18px] font-semibold">Nothing to show (yet)</p>
        <p  style="color: #515765;" class=" text-sm	 font-normal">Click ‘refresh’ below after uploading items from your mobile device.</p>
        <img src="assets/images/no-file-mobile.svg" style="padding: 12px;" class=" bg-[#FFFFFF]  " />
        <button
          class="app__btn--primary mb-[24px] mt-0 max-[480px]:items-center w-[296px] max-[480px]:h-[38px] max-[480px]:m-0"
          type="submit"
          style="margin: auto;"
          (click)="refreshFile()"
          >
          <mat-icon>refresh</mat-icon> Refresh
        </button>
      </div>
    </div>
  }
  @if (fileList?.length && !isLoading) {
    <div
      (drop)="dragged($event)"
      draggable="true"
      (dragstart)="onDragStart($event)"
      (drag)="onDrag($event)"
      (dragover)="onDrag($event)"
      (dragend)="onDragEnd($event)"
      (dragleave)="myFunction($event)"
      [class.dropzone-preview]="isActiveDrag"
      class="flex flex-col w-full  rounded-xl border-solid border border-[#53565B38]  mt-[16px] ">
      <div>
        <div class="flex justify-between  " >
          @if (origin == 'onboarding') {
            <p class="px-2 text-base font-normal decoration-[#010B18] mt-4" >
              Uploads <b>• {{completedCount}} of {{fileList?.length}}</b> Items Complete
            </p>
          }
          @if (origin == 'mobile') {
            <p class="px-2 text-base font-normal decoration-[#010B18] mt-4" >
              Recent Uploads <b>• {{completedCount}}</b> Items <mat-icon
              class="relative top-1.5 cursor-pointer text-[#ffffff] rounded-[100px] bg-[#25508E] "
            (click)="refreshFile()" >refresh</mat-icon>
          </p>
        }
        <div>
          <p  style="line-height: 32px !important; margin-top: 12px;margin-right: 24px;height: 32px;" class="rounded text-[#25508E] text-xs font-bold w-32 border-solid border text-center border-[#25508E]"
            [matMenuTriggerFor]="addMenu"
            #menuAdd="matMenuTrigger"
            (menuOpened)="(menuAdd.menuOpen)"
            (menuClosed)="(menuAdd.menuOpen)"
            >
            <img src="assets/images/upload-cloud.svg" /> New Upload
          </p>
          <mat-menu #addMenu="matMenu" yPosition="below" xPosition="before" class="dropdown-menu-panel">
            <div class="upload-file">
              <input type="file" (change)="onFileChanged($event, true)" multiple #fileInput style="display: none" />
              <button mat-menu-item (click)="fileInput.click()" class="h-8 font-semibold text-sm">
                <img  src="assets/images/upload-file.svg" />
                Upload File
              </button>
            </div>
            <div class="upload-folder">
              <input
                type="file"
                name="files"
                accept=".iso"
                webkitdirectory
                mozdirectory
                directory
                multiple
                id="files"
                (change)="onFileChanged($event, false)"
                #folderInput
                style="display: none"
                />
                <button mat-menu-item (click)="folderInput.click()" class="h-8 font-semibold text-sm">
                  <span style="position: relative;top: 4px;left: -4px;color: #25508E;font-size: 20px;" class="material-icons material-icons-round common-menuitem-icon">folder_open</span>Upload Folder
                </button>
              </div>
            </mat-menu>
          </div>
        </div>
        <div>
          <div style="height: 38px;" class=" flex justify-between border-solid border-y border-[#53565B38]">
         <h6 style="color: #ABA5A3; height: 38px;
         margin-bottom: 0px;
         line-height: 38px !important;" class="pl-3	  w-7/12 font-semibold text-sm" >Files</h6>
         <h6  style="color: #ABA5A3; height: 38px;
         margin-bottom: 0px;
         line-height: 38px !important;" class=" text-center w-2/12 font-semibold text-sm" >Size</h6>
         <h6 style="color: #ABA5A3; height: 38px;
         margin-bottom: 0px;
         line-height: 38px !important;" class=" text-center w-3/12 font-semibold text-sm" >Status</h6>
          </div>
          @for (file of fileList; track file; let i = $index; let last = $last) {
            <div class=" flex justify-between border-solid  border-[#53565B38] m-0 h-12" [style.border-bottom]="last ? '0px' : '1px'" >
              <p class="pl-3	 w-7/12  m-0  font-semibold text-sm text-truncate h-12 " style="line-height: 48px !important;color: #18191c;" >
                <img src="assets/images/file-icon.svg" />
                {{file.name  }}
              </p>
              <p class="w-2/12 text-center  m-0 h-12" style="line-height: 48px;">
                {{file.size | sizeConvertor}}
              </p>
              @if (file.status == 'running') {
                <div  class="pt-3.5 text-center w-3/12 h-12 m-0">
                  <mat-spinner [diameter]="20" style="margin: auto;" > </mat-spinner>
                </div>
              }
              @if (file.status == 'success') {
                <div   class="pt-3.5 text-center w-3/12 h-12 m-0">
                  <img src="assets/images/completed-check.svg" />
                </div>
              }
              @if (file.status == 'fail') {
                <div   class="pt-3.5 text-center w-3/12 h-12 m-0">
                  X
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (isLoading) {
    <div class="loader-container mt-[24px]" style="width: 100%;display: flex;flex-direction: column;">
      @for (item of loadingItems; track item) {
        <div>
          <div class="flex loader-body" style="width: 100% !important;" id="{{ item.id }}">
            <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px">
              <div class="ph-col-12" style="padding: 0px !important">
                <div class="ph-row">
                  <div class="ph-col-12"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }

